import React from 'react';

import { FormControlLabel, Radio, Grid, makeStyles, RadioGroup, Typography, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles(() => {
  return {
    noAdminTypography: {
      color: '#999999',
      fontSize: '12px',
      fontWeight: 400,
    },

    notificationHeader: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
  };
});

export default ({ admins = [], selectedAdmins = [], onUpdateSelectedAdmins, notifyMe, onUpdateNotifyMe }) => {
  const classes = useStyles();
  const handleUpdateSelectedAdmins = (_event, value) => {
    if (onUpdateSelectedAdmins) onUpdateSelectedAdmins(value);
  };

  const handleUpdateNotifyMe = (_event, value) => {
    if (onUpdateNotifyMe) onUpdateNotifyMe(value);
  };

  return (
    <Grid container>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <Typography className="field-label text-left mt-1 mb-1">Notify me</Typography>

        <RadioGroup onChange={handleUpdateNotifyMe} value={notifyMe}>
          <FormControlLabel control={<Radio color="primary" checked={notifyMe === 'yes'} />} label="Yes, notify me." value="yes" />
          <FormControlLabel control={<Radio color="primary" checked={notifyMe === 'no'} />} label="No, don't notify me." value="no" />
        </RadioGroup>
      </Grid>

      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <Typography className="field-label text-left mt-1 mb-1">Notify others</Typography>

        {admins.length ? (
          <Autocomplete
            multiple
            value={selectedAdmins}
            onChange={handleUpdateSelectedAdmins}
            renderInput={(params) => <TextField {...params} size="small" variant="outlined" placeholder="Select admin" />}
            options={admins || []}
            getOptionLabel={(option) => option.name}
          />
        ) : (
          <Typography className={`text-left ${classes.noAdminTypography}`}>No admin found</Typography>
        )}
      </Grid>
    </Grid>
  );
};
